/**
 * Initialization manager to prevent duplicate initialization calls
 * Ensures initialize() only runs once, even if called from multiple places
 */

import { initialize } from './initialize';
import { createErrorLogger } from './errorHandler';

const logger = createErrorLogger('initializeManager');

// Track ongoing initialization to prevent duplicates
let initializationPromise = null;
let isInitializing = false;

/**
 * Initialize with lock mechanism
 * If initialization is already in progress, returns the existing promise
 * @returns {Promise} Promise that resolves when initialization completes
 */
export const initializeWithLock = async () => {
  // If initialization is already in progress, return the existing promise
  if (isInitializing && initializationPromise) {
    return initializationPromise;
  }

  // Mark as initializing
  isInitializing = true;

  // Create the initialization promise
  initializationPromise = initialize()
    .then((result) => {
      return result;
    })
    .catch((error) => {
      logger.error('Initialization failed', error);
      // Reset state on error so retry is possible
      initializationPromise = null;
      isInitializing = false;
      throw error;
    })
    .finally(() => {
      // Reset state after a short delay to allow concurrent calls to use the promise
      setTimeout(() => {
        isInitializing = false;
        initializationPromise = null;
      }, 100);
    });

  return initializationPromise;
};

